module.exports = __webpack_public_path__ + "6dbd6b96782299aa592492a3e6d94d81.jpg";